import { css } from '@emotion/react';
import { IonButtons, IonCol, IonGrid, IonIcon, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { close } from 'ionicons/icons';
import React from 'react';
import { ReactFitty } from 'react-fitty';
import * as commonCss from '../../styles/common';
import { ShareDatasourceDetails } from '../ShareDatasourceDetails';
import { SkeletonText } from '../SkeletonText';
import { Title } from '../Title';
import { ToolbarButton } from '../ToolbarButton';
import { FollowDatasourceButton } from '../FollowDatasourceButton';
import { AirQualityMarkerDto, NetworkV2Dto } from '../../types';

interface DatasourceHeaderProps {
  marker: AirQualityMarkerDto | null;
  network: NetworkV2Dto | null;
  onClose: () => void;
}

export const DatasourceHeader: React.FC<DatasourceHeaderProps> = ({ marker, network, onClose }) => {
  const headerCss = {
    toolbar: css({
      padding: '0 !important',
      '--min-height': '32px',
    }),
    buttons: [
      css({
        gap: '.3rem',
      }),
    ],
    title: [
      commonCss.noPadding,
      css({
        marginRight: '.5rem',
      }),
    ],
  };

  return (
    <IonGrid>
      <IonRow>
        <IonCol>
          <IonToolbar css={headerCss.toolbar} mode="md">
            <IonTitle css={headerCss.title}>
              {marker?.datasourceName ? (
                <Title>
                  <ReactFitty maxSize={commonCss.MAX_FONT_SIZE_PX}>{marker.datasourceName}</ReactFitty>
                </Title>
              ) : (
                <SkeletonText width="80%" height="min(5vw, 1.25rem)" margin="none" />
              )}
            </IonTitle>
            <IonButtons css={headerCss.buttons} slot="end">
              {marker && network?.isNotificationEnabled && <FollowDatasourceButton marker={marker} network={network} />}
              <ShareDatasourceDetails />
              <ToolbarButton onClick={onClose}>
                <IonIcon icon={close} slot="icon-only" />
              </ToolbarButton>
            </IonButtons>
          </IonToolbar>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
